import React, {useState, useEffect} from 'react'
import { Row } from 'react-bootstrap';
import Logo from '../Images/Logo.png';
import {RiDownloadLine} from 'react-icons/ri'
import {HiOutlineDocumentText} from 'react-icons/hi'
import myFile from '../Download/Logo.pdf'
import myAPK from '../Download/app-release.apk'
import { generate } from "short-id";
import AutoExpire from "../Emoji/AutoExpire";
import EmojiBubble from "../Emoji/EmojiBubble";

const UpperBody = () => {

    const [emojiQueue, setEmojiQueue] = useState([]);
    
    const randomNumber = (max, min) => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    
      const randomPosOrNeg = (max, min) => {
        let randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
    
        randomNumber *= Math.floor(Math.random() * 2) === 1 ? 1 : -1;
    
        return randomNumber;
      };
    
      const handleEmojiClick = (label, symbol) => {
        setEmojiQueue([
          ...emojiQueue,
          {
            label,
            symbol,
            size: randomNumber(3, 2),
            left: randomNumber(100, 0),
            one: randomPosOrNeg(200, 50),
            two: randomPosOrNeg(200, 50),
            id: generate()
          }
        ]);
      };

      const [count, setCount] = useState(false);
      const [animate, setAnimate] = useState("false")

      function myAnimateFunc() {
        setCount(false)
        setAnimate("sign out")
      }

      useEffect(() => {
        setTimeout(() => {
          setCount(true)
          setAnimate("false")
        }, [1000])
        if (count === false && animate === "sign out") {
          handleEmojiClick("label", "🤓");
        }
      },);
    return (
        
        <div className = "UpperBody">
            {<div style={{ zIndex: "999", bottom:"0", right:"0" , position:"fixed", height:"100%", }}>
          {emojiQueue.map(({ id, label, symbol, size, left, one, two }) => (
            <AutoExpire key={id}> 
              <EmojiBubble
                label={label}
                symbol={symbol}
                size={size}
                left={left}
                one={one}
                two={two}
              />
            </AutoExpire>
          ))}
        </div> }
            <img className="App-logo" src={Logo} alt="Logo"></img>
            <div className="heading">
                <span>Ba</span>
                <span style={{color: "#69F0AE"}}>ll</span>
                <span>ance</span>
            </div>
            <div className="subHeadingParent">
             <div className="subHeading">"Discover the difference"</div>
            </div>
            <div className="Button">
                <Row style={{marginTop: "3rem"}}>

                    <span onClick={()=>myAnimateFunc()}>

                    <a href = {myFile} download style={{padding: "10px", color: "white", fontSize:"1.9rem"}}><HiOutlineDocumentText></HiOutlineDocumentText></a>


                    </span>
                
             
                        <a href = {myAPK} download style={{padding: "10px", color: "white", fontSize:"1.9rem"}}><RiDownloadLine></RiDownloadLine></a>
                    
                   
                </Row>
            </div>
        </div>
    )
}

export default UpperBody
